<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-24 15:38:15
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-27 15:34:57
 * @FilePath: /goldenSalesMobile/src/views/Result/index.vue
 * @Description: 支付/退款申请结果页面
-->
<template>
  <div class='page-container'>
    <nav-bar :title="title" />
    <div class="status-img">
      <img v-if="status === 'success'" src="../../assets/common_image/success.png" alt="">
      <img v-else src="../../assets/common_image/fail.png" alt="">
    </div>
    <p class="status-txt">{{ statusTxt }}</p>
    <p v-if="status === 'success' && type === 'withdraw'" class="withdraw-tips">提现金额将到“微信-钱包-零钱”中</p>
    <p v-if="status === 'fail' && failReason" class="fail-reason">{{ failReason }}</p>
    <div class="attention-tips" v-if="isAttention === '0'">
      <van-image :src="storeQrCode" fit="cover" />
      <p>长按识别二维码关注公众号</p>
      <p>避免订单走丢哦~</p>
    </div>
    <div v-if="status === 'success' && type !== 'withdraw'" class="fixed-btn">
      <van-button
        block
        :to="{name: 'UsersOrder'}"
      >
        订单列表
      </van-button>
      <van-button
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        :to="{name: 'ConsumeCode', params: {id: orderId}}"
      >
        查看消费码
      </van-button>
    </div>
    <div v-if="status === 'fail' && type !== 'withdraw'" class="fixed-btn">
      <van-button
        block
        @click="onClose"
      >
        取消
      </van-button>
      <van-button
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        @click="onRetry"
      >
        {{ failBtnTxt }}
      </van-button>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  data() {
    return {
      orderId: this.$route.params.id,
      title: '',
      status: this.$route.params.status,
      statusTxt: '',
      type: this.$route.params.type,
      failReason: sessionStorage.getItem('failReason'),
      failBtnTxt: '',
      storeQrCode: '',
      // isAttention: localStorage.getItem('isAttention')
      isAttention: store.state.isAttention,
    }
  },
  
  created() {
    if (this.type === 'pay') {
      this.title = '支付'
      this.failBtnTxt = '重新购买'
      this.statusTxt = this.status === 'success' ? '购买成功' : '购买失败'
    } else if (this.type === 'refund') {
      this.title = '退款'
      this.failBtnTxt = '重新申请'
      this.statusTxt = this.status === 'success' ? '申请成功' : '申请失败'
    } else if (this.type === 'withdraw') {
      this.title = '提现'
      this.statusTxt = this.status === 'success' ? '提现成功' : '提现失败'
    } else {
      this.$toast(`未定义的路由类型${type}`)
    }
    if(process.env.VUE_APP_CURRENTMODE === 'production') {
      this.storeQrCode = require('../../assets/common_image/ypm_QrCode.jpg')
    } else {
      this.storeQrCode = require('../../assets/common_image/xishi_QrCode.jpg')
    }
  },

  methods: {
    onClose() {
      wx.closeWindow();
    },

    onRetry() {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang='scss' scoped>
  .page-container {
    background: $blockBgColor;

    .status-img {
      width: 372px;
      height: 372px;
      margin: 40px auto 52px;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    .status-txt {
      margin-bottom: 24px;
      text-align: center;
      line-height: 76px;
      font-size: 54px;
      font-weight: 500;
      color: $secondFontColor;
    }

    .withdraw-tips {
      text-align: center;
      line-height: 48px;
      font-size: 34px;
      color: $secondFontColor;
    }

    .fail-reason {
      text-align: center;
      line-height: 48px;
      font-size: 34px;
      font-weight: 400;
      color:$secondFontColor;
    }

    .attention-tips {
      @include flex-box(center);
      flex-direction: column;
      margin-bottom: 120px;
      &::v-deep .van-image {
        width: 172px;
        height: 172px;
        margin-bottom: 20px;
      }

      >p {
        text-align: center;
        line-height: 1.5;
        font-size: 28px;
        color: $secondFontColor;
      }
    }

    .fixed-btn{
      display: flex;

      &::v-deep .van-button:first-child {
        box-shadow:0px 4px 20px 0px rgba(255,200,99,1);
        border:2px solid;
        border-image:linear-gradient(180deg, rgba(251,169,33,1), rgba(251,202,57,1)) 2 2;
        font-size: 18px;
        font-weight: 500;
        line-height: 48px;
        color: rgba(250,155,0,1);
      }

      &::v-deep .van-button:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
</style>
